import FieldsService from './fieldsService';

const FieldsServiceInstance = new FieldsService();

export default FieldsServiceInstance;
